import { createAction, props } from '@ngrx/store';

export const RequestDataForExportSuccess = createAction(
  '[Export] - Request Data For Export Success',
  props<{ id: string; format: string; data: any }>()
);
export const RequestDataForExportFailure = createAction('[Export] - Request Data For Export Failure', props<{ id: string; error?: any }>());
